import React from "react";

import {
  RotateCcw
} from "react-feather";

//components
import IconButton from "./IconButton";

const Reload = (props) => {

  return (
    <div className="mt-20 u-d-flex u-flex-column u-align-center u-justify-center">
      <IconButton type="button" variant="danger" onClick={props.onClick}>
        <RotateCcw />
      </IconButton>
      <p className="u-d-block u-text-center notfound-text">{props.title}</p>
      <p className="u-d-block u-text-center">{props.message}</p>
    </div>
  );
}

Reload.defaultProps = {
  title: "Title",
  message: "Info message"
}

export default Reload;